document.addEventListener("DOMContentLoaded", function() {
  var descElements = document.getElementsByClassName("u-u-u-accordion-item-desc");
  for (var j = 0; j < descElements.length; j++) {
    descElements[j].style.maxHeight = descElements[j].scrollHeight + "px";
  }
  var coll = document.getElementsByClassName("u-accordion-item-title");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var desc = content.querySelector(".u-u-u-accordion-item-desc");
      if (content.style.maxHeight) {
        content.style.maxHeight = null; 
      } else {
        content.style.maxHeight = content.scrollHeight + "px"; 
      }
    });
  }
});